import {
  HTTPValidationError,
  saveEcrfSubmissionReadTasksReadTasksPatch,
  SaveEcrfSubmissionReadTasksReadTasksPatchResponse,
  SaveEcrfSubmissionReadTasksReadTasksPatchData,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const UsePatchTaskMutation = (): UseMutationResult<
  SaveEcrfSubmissionReadTasksReadTasksPatchResponse,
  AxiosError<HTTPValidationError>,
  SaveEcrfSubmissionReadTasksReadTasksPatchData
> => {
  return useMutation<
    SaveEcrfSubmissionReadTasksReadTasksPatchResponse,
    AxiosError<HTTPValidationError>,
    SaveEcrfSubmissionReadTasksReadTasksPatchData
  >({
    mutationFn: async ({ body, query }) => {
      const response = await saveEcrfSubmissionReadTasksReadTasksPatch({
        body: body,
        query: query,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ReadTasksList'] })
    },
  })
}
